module.exports = __webpack_public_path__ + "static/media/judge.902f0fe8.jpg";